"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _GroupBuyTablePane = _interopRequireDefault(require("./GroupBuyTablePane"));
var _GroupBuyConfigPane = _interopRequireDefault(require("./GroupBuyConfigPane"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'group_buy',
  components: {
    GroupBuyTablePane: _GroupBuyTablePane.default,
    GroupBuyConfigPane: _GroupBuyConfigPane.default
  },
  data: function data() {
    return {
      activeName: 'table',
      groupBuyFnId: null
    };
  },
  created: function created() {},
  methods: {
    handleConfig: function handleConfig(groupBuyFnId) {
      this.activeName = 'config';
      this.groupBuyFnId = groupBuyFnId;
    },
    handleSuccess: function handleSuccess() {
      this.activeName = 'table';
      this.$refs.group_buy_table_pane.search();
      this.groupBuyFnId = null;
    }
  }
};